<div class="modal-header">
	<h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.querySelect}}</h3>
</div>
<div class="modal-body">
	<div class="well">
		<div>{{LOCALIZATION.annotationsCombination}}</div>
		<div class="radio-inline">
		  <label>
		    <input type="radio" [(ngModel)]="queryData.resultAction" (click)="setMode('Append')" value="append">
		    {{LOCALIZATION.appendFields}}
		  </label>
		</div>			
		<div class="radio-inline">
		  <label>
		    <input type="radio" [(ngModel)]="queryData.resultAction" (click)="setMode('Replace')" value="update">
		    {{LOCALIZATION.replaceFields}}
		  </label>
		</div>	
	</div>
	<div>
       <div *ngIf="isParagraphsEnabled">
            <label for="paragraphs">{{LOCALIZATION.searchParagraphs}}</label>
            <div class="toggle-switch">
                <input id="paragraphs" class="toggle-switch-toggle toggle-switch-toggle-round" type="checkbox" [(ngModel)]="queryData.searchParagraphs">
                <label for="paragraphs"></label>
            </div>
       </div>		
	</div>
	
	<!-- Each grid is displayed in its own tab -->
	<ul ngbNav #nav="ngbNav" class="nav nav-tabs">
	  <li ngbNavItem class="nav-item">
	    <a class="nav-link" ngbNavLink>
	      {{ LOCALIZATION.queryLists }}
	    </a>
	    <ng-template ngbNavContent>
			<!-- Grid displaying selectable workflow query lists -->
			<workflow-querylist-selector></workflow-querylist-selector>	    
	    </ng-template>
	  </li>
	  <li ngbNavItem class="nav-item">
	    <a class="nav-link" ngbNavLink>
	      {{ LOCALIZATION.queries }}
	    </a>	    
	    <ng-template ngbNavContent>
		   	<!-- Grid displaying selectable workflow queries -->
			<workflow-query-selector></workflow-query-selector>
	    </ng-template>
	  </li>
	  <li ngbNavItem class="nav-item" [hidden]="!isNEREnabled">
	    <a class="nav-link" ngbNavLink>
	      {{ LOCALIZATION.entityExtraction }}
	    </a>
	    <ng-template ngbNavContent>
			<!-- Grid displaying selectable workflow NER queries -->
			<workflow-ner-selector></workflow-ner-selector>	    
	    </ng-template>
	  </li>	  
	</ul>
	<div [ngbNavOutlet]="nav" class="tab-content"></div>	
	
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
	<button class="btn btn-primary" type="button" (click)="submit()">{{LOCALIZATION.submit}}</button>
</div>
